import React, { useContext } from 'react'
import styled from 'styled-components'
import {
  alignSelf as alignSelfStyle,
  fontWeight as fontWeightStyle,
  textAlign as textAlignStyle,
  fontSize as fontSizeStyle,
  space as spaceStyle,
  FontSizeProps,
  SpaceProps,
  TextAlignProps
} from 'styled-system'
import { Content } from '@pcln/ace-content-react'
import { Heading, Text } from 'pcln-design-system'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const StyledH1 = styled(Heading.h1)`
  ${fontSizeStyle};
  ${textAlignStyle};
`

const StyledH2 = styled(Heading.h2)`
  ${alignSelfStyle};
  ${textAlignStyle};
  ${fontWeightStyle};
  ${spaceStyle};
`

type Headings = {
  [key: string]: React.ElementType
}

const HEADINGS: Headings = {
  h1: StyledH1,
  h2: StyledH2
}

type StyledHeadingType = FontSizeProps &
  SpaceProps &
  TextAlignProps & {
    color?: string
    aceContent?: string[]
    text: string
    tag: 'h1' | 'h2'
    lineHeight?: string
  }

export default function StyledHeading({
  color = 'text.base',
  aceContent = [],
  text,
  fontSize = [3, 4, null, 5],
  textAlign,
  tag,
  ...props
}: StyledHeadingType) {
  const Component = HEADINGS[tag]
  const { isMobile = false } = useContext(BootstrapDataContext)
  const bold = isMobile ? '600' : '700'

  return (
    <Component
      fontSize={fontSize}
      fontWeight={tag === 'h2' ? '400' : bold}
      textAlign={textAlign || 'left'}
      color={color}
      m={0}
      {...props}
    >
      {aceContent.length === 0 ? (
        <Text>{text}</Text>
      ) : (
        <Content fallback={text} name={aceContent} />
      )}
    </Component>
  )
}
